import { gql } from "@apollo/client"

export const GET_ORGANIZATIONS = gql`
  query getAllOrganizationsAndGroups {
    allOrganizations {
      id
      name
      groups(first: 20) {
        id
        name
      }
    }
  }
`
